import { styled } from 'parkdepot-shared'

export const CardWrapper = styled<'div', { disabled?: boolean }>('div', ({ $theme, disabled = false }) => ({
    position: 'absolute',
    bottom: '12px',
    left: 0,
    width: '-webkit-fill-available',
    minHeight: '11rem',
    backgroundColor: '#F6F6F6',
    display: 'flex',
    borderRadius: '1.4rem',
    margin: '0 1.6rem',
    cursor: disabled ? 'not-allowed' : 'pointer',
    padding: '2.4rem',

    [$theme.mediaQuery.large]: {
        marginTop: '2.4rem'
    }
}))

export const DataContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column'
})

export const Title = styled('h3', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 600,
    margin: 0
}))

export const Data = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 400,
    margin: 0
}))

export const ButtonContainer = styled('div', {
    margin: 'auto 0 0 auto'
})
